/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Spanish(Colombia) language
 *
 * @file es-co.js
 * @author Manimaran.S
 */

const esCo = {
  'popularChannelSlider.allChannels': 'Todos los canales',
  'popularChannelSlider.recommended': 'Recomendado',
  'hero.myetextbook.link': 'de libros electrónicos',
  'hero.myetextbook.text': '¿No es el título correcto? Acceda a su biblioteca',
  'hero.etextfeaturestitle': 'Encuentre materiales de estudio en su libro electrónico',
  'hero.etextfeaturesdescription': 'Su libro electrónico viene con materiales de estudio diseñados para que tenga éxito. Estudie con tarjetas didácticas y otros recursos directamente desde su libro electrónico.',
  'aichat.title1': 'Obtenga ayuda basada en IA para todo lo relacionado con este libro electrónico.',
  'aichat.chatDesc1': 'Escriba una pregunta para empezar',
  'subscriptiontext.isSubscribed': 'Parte de su suscripción',
  'subscriptiontext.nonSubscriber': 'Actualice su suscripción para obtener acceso completo',
  'topicConatiner.otherHeader': 'Videos y práctica relacionados',
  'topicConatiner.exactLiteHeader': 'Conceptos y práctica relacionados',
  'moremenu.downloadApp': 'Descargar la aplicación',
  'moremenu.downloadAppAlreadyDownload': '%Click here% para descargar la aplicación en otro dispositivo e iniciar sesión automáticamente o para usar su código QR único e iniciar sesión de forma segura en la aplicación que instaló.',
  'moremenu.downloadAppNotDownload': '%Click here% para descargar la aplicación e iniciar sesión de forma segura con su código QR único.',
  'channel.noBundletitle': 'Use Preparación para estudiar para cursos relacionados y otros cursos',
  'onboard.studyPlan': 'Se creó un plan de estudio personalizado.',
  'onboard.addCourseAnother': '¿Quiere añadir otro curso?',
  'onboard.purchase': 'Necesito comprar un libro electrónico de Pearson',
  'onboard.addCourseWithoutEtext': 'Agregue un curso usando Preparación para estudiar',
  'onboard.mayBeLater': 'Quizás luego',
  'onboard.aboutCourse': 'Cuéntenos sobre su curso',
  'onboard.close': 'Cerrar',
  'course.addTitle': 'Añadir curso',
  'common.PURCHASE': 'Comprar',
  'common.CLOSE': 'Cerrar',
  'open': 'abrir',
  'continue': 'Continuar',
  'yes': 'Sí',
  'no': 'No',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': '¡Éxito!',
  'courses.toc.PUBLISH_MESSAGE': 'Los estudiantes verán sus cambios la próxima vez que abran el contenido.',
  'errors.GENERIC_TITLE': 'No tiene acceso en este momento',
  'errors.GENERIC_DESC': 'Primero, actualice o borre su caché. Si eso no funciona, comuníquese con ',
  'errors.GENERIC_LINK': 'el soporte de Pearson.',
  'errors.GENERIC_CODE': 'Código de error: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Suscripción no encontrada',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Su cuenta no incluye acceso a este título. Si cree que recibió este mensaje por error, póngase en\n      rcontacto con el Servicio de Asistencia Técnica de Pearson.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Suscripción no encontrada',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Su suscripción no incluye acceso a eText; sin embargo, puede suscribirse ahora mismo con una \n    tarjeta de crédito.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mi cuenta',
  'menu.helpCenter': 'Centro de asistencia',
  'menu.preferencesCenter': 'Centro de preferencias',
  'menu.CONTACT_SUPPORT': 'Contactar al Servicio de Asistencia Técnica',
  'menu.HELP_SUPPORT': 'Ayuda y soporte',
  'menu.FAQS': 'Preguntas frecuentes',
  'menu.CHAT_WITH_SUPPORT': 'Hable con el soporte',
  'menu.OTP_CODES': 'Códigos de OTP',
  'menu.LAUNCH_CODE': 'Iniciar el registro de códigos',
  'menu.SEND_CODE': 'Enviar un código nuevo al usuario por correo electrónico',
  'menu.SEND_CODE_PHONE': 'Enviar un código nuevo al usuario por mensaje de texto',
  'menu.LEGAL': 'Legal',
  'menu.PRIVACY_NOTICE': 'Aviso de privacidad',
  'menu.TITLE_INFO': 'Información del título',
  'menu.PEARSON_ACCESSIBILITY': 'Accesibilidad Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registre {deviceLimit} dispositivos. Intercambie 1 al mes.',
  'menu.ACCESSIBILITY': 'Accesibilidad',
  'menu.ACCESSIBILITY_SUPPORT': 'Soporte de accesibilidad',
  'menu.DEVICES': 'Dispositivos recientes',
  'menu.THIS_DEVICE': 'Este dispositivo',
  'menu.GET_THE_APP_DOWNLOAD': 'Descargar la aplicación móvil',
  'menu.MOJO_APP_INFO': 'Visite la tienda de aplicaciones en su teléfono inteligente o tableta para usar Pearson+ sin conexión.',
  'menu.DEVICE_LABEL': 'Dispositivo',
  'menu.DEVICE_DISCONNECT': 'Desconectar',
  'menu.FOXIT': 'Potenciado por Foxit',
  'menu.TERMS_OF_USE': 'Términos de uso',
  'menu.SIGN_OUT': 'Cerrar sesión',
  'menu.PRINT_PAGE': 'Imprimir página',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Todos los derechos reservados.',
  'print.FOOTER_MESSAGE': 'Impreso por {fullName}({email}) el {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Ya ha hecho un intercambio este mes',
  'device.SWITCH_DEVICE': '¿Cambiar al dispositivo actual?',
  'device.SWITCH_ONCE': 'Dado que solo puede cambiar una vez al mes, no podrá deshacer esta acción.',
  'device.SEAT_TAKEN': 'Ese asiento está ocupado',
  'device.DISCONNECT_DEVICE': 'Solo puede iniciar sesión en 3 dispositivos. Para continuar aquí, desconecte otro dispositivo.',
  'device.ALERT_TEXT': 'Recuerde que solo puede cambiar de dispositivo una vez al mes.',
  'device.DISCONNECT': 'Desconectar',
  'device.CONTINUE': 'Continuar',
  'device.HEADER': '¿Desea cerrar la sesión del otro navegador?',
  'device.CLOSE': 'Regresar a inicio',
  'device.CODE': 'Continúe aquí ingresando el código de autenticación que le enviamos a {maskedEmail}. ¿No funciona? Revise su carpeta de correo no deseado, {email}, o comuníquese con {support}.',
  'device.TIMER': 'Tiene {time} para ingresar su código aquí',
  'device.RESEND': '{resend}',
  'device.FAQ': 'PREGUNTAS FRECUENTES',
  'device.RESEND_NAME': 'Reenviar',
  'device.NOTE': 'Si usa Pearson+ en 2 lugares regularmente, como en el trabajo y en el hogar, asegúrese de cerrar sesión cuando termine. También puede usar la aplicación móvil Pearson+ hasta en 2 dispositivos. Para obtener más información, consulte {faq}.',
  'device.NOTE_HEADER': 'Evite esto la próxima vez',
  'device.CONTACT_SUPPORT': 'Servicio de Asistencia al Cliente',
  'device.CONTACT_EMAIL': 'actualice su dirección de correo electrónico',
  'device.INCORRECT': 'Incorrecto: vuelva a verificar el código o solicite que se le reenvíe.',
  'device.MANY_ATTEMPTS': 'Realizó demasiados intentos, pruebe solicitar el reenvío del código',
  'device.EXPIRED': 'El tiempo ha expirado, pruebe solicitar el reenvío del código',
  'device.ACCESS_HEADER': '¡Ha ingresado!',
  'device.ACCESS_DESC': 'Su sesión se ha autenticado. ¿Quiere aprovechar y actualizar su contraseña?',
  'device.ACCESS_CHANGE_PASSWORD': 'Cambiar contraseña',
  'device.ACCESS_RESET_PASSWORD': 'Restablecer contraseña',
  'device.THREATONE_TITLE': '¿Está todo bien?',
  'device.THREATONE_DESC': '"Notamos una actividad sospechosa en su cuenta."',
  'device.THREATONE_DESC_TWO': 'Este es un buen momento para cambiar su contraseña.',
  'device.MAY_BE_LATER': 'Quizás luego',
  'device.OKAY': 'Aceptar',
  'device.ACCOUNT_LOCK_DESC': 'Por seguridad, cerraremos la sesión. Le enviamos un enlace de restablecimiento de contraseña al correo electrónico asociado con su cuenta.',
  'device.ACCOUNT_LOCK_TITLE': 'Notamos una actividad sospechosa en su cuenta',
  'device.ACCOUNT_LOCK_TIMER': 'La sesión se cerrará en {time}',
  'navigation.PAGE': 'Página',
  'launchcode.CREATEBY': 'Creado por:',
  'launchcode.sentvia': 'Enviado a través de:',
  'launchcode.CODEINLAST': 'Códigos de los últimos siete días:',
  'launchcode.TIMESENT': 'Hora de envío:',
  'launchcode.ACCOUNTEMAIL': 'Correo electrónico de la cuenta:',
  'launchcode.LAUNCHDIALOGTITLE': 'Registro de códigos de OTP',
  'textmessage.TITLE': 'Ingresar número de teléfono',
  'textmessage.PHONE_NUMBER': 'Número de teléfono',
  'textmessage.SEND_CODE': 'Enviar código',
  'textmessage.INVALID_NUMBER': 'El número de teléfono móvil no es válido.',
  'textmessage.SUCCESS_MESSAGE': 'Código enviado',
  'remove.title': '¿Desea eliminar el título?',
  'remove.subTitle': 'Puede volver a recuperarlo más adelante, simplemente utilice la búsqueda para volver a agregarlo.',
  'remove.buttonText': 'Eliminar',
  'search.searchPlaceHolderPPlus': 'Buscar por ISBN, título o autor',
  'search.searchPlaceHolderEText': 'Busque en su biblioteca',
  'footer.downloadMobileApp': 'Descargar la aplicación móvil',
  'footer.termsOfUse': 'Términos de uso',
  'footer.privacy': 'Privacidad',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'No vendan mi información personal',
  'footer.accessibility': 'Accesibilidad',
  'footer.patentNotice': 'Aviso de patente',
  'footer.copyrights': 'Pearson Todos los derechos reservados.',
  'hero.toc.defaultPlacehoder': '--- seleccionar un tema ---',
  'hero.openEtextBookV1': 'Abrir libro electrónico',
  'hero.heroHeading': 'Porque está estudiando <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Preparación para estudiar',
  'hero.study.help': 'Obtenga ayuda para el estudio',
  'hero.study.jumpBackIn': 'Volver hacia atrás en',
  'hero.study.numOfUsers': 'Actualmente, <b>{num_of_users}</b> estudiantes están usando Canales.',
  'hero.heroChannel.cardsHeading': 'Continúe donde se haya quedado',
  'hero.marketingcard1.copy.title': 'Aprenda con videos',
  'hero.marketingcard1.copy.description': 'Vea videos explicativos breves en los que se analizan los temas complicados.',
  'hero.marketingcard2.copy.title': 'Problemas de práctica',
  'hero.marketingcard2.copy.description': 'Prepárese para su examen con miles de preguntas de examen y videos con soluciones.',
  'hero.marketingcard3.copy.title': 'Obtenga ayuda experimentada',
  'hero.marketingcard3.copy.description': 'Publique preguntas y reciba respuestas de expertos en el tema.',
  'hero.popularTopics.heading': 'Otros temas populares de este canal',
  'hero.popularChannels.headingv1': '¿Está realizando otro curso?',
  'hero.popularChannels.descriptionv2': 'Explore temas populares de ayuda con el estudio.',
  'hero.practice': 'Practicar',
  'hero.herobook.mappedChannelHeading': 'Ayuda con el estudio recomendada en este canal',
  'libraryL2.myBooks': 'Mis libros',
  'libraryL2.archived': 'Archivado',
  'libraryL2.back': 'Atrás',
  'hero.practiceProblem': 'Problema de práctica',
  'nativeAppBanner.drawer.title': 'Abrir en...',
  'nativeAppBanner.drawer.pearsonApp': 'Aplicación Pearson+',
  'nativeAppBanner.banner.title': 'Aplicación Pearson+',
  'nativeAppBanner.banner.description': 'Aprender en cualquier lugar',
  'hero.promotionalcard.list1': 'Videos breves que abordan temas complicados',
  'hero.promotionalcard.list2': 'Miles de preguntas similares a las del examen',
  'hero.promotionalcard.list3': 'Reciba respuestas de expertos en el tema',
  'hero.studyandexamprep': 'Preparación para estudiar',
  'hero.heroBook.sectionSubHeadingV1': 'Aborde los temas difíciles con preguntas de práctica y explicaciones de video adaptadas a su curso.',
  'hero.heroBook.sectionSubHeadingV2': 'Aborde los temas difíciles con preguntas de práctica y explicaciones de conceptos adaptadas a su curso.',
  'hero.SeeAllStudyOptions': 'Ver todas las opciones de estudio',
  'hero.herobook.mappedChannelHeadingV1': 'Videos y preguntas de práctica recomendados',
  'hero.popularTopics.headingV1': 'Otros temas populares',
  'hero.heroHeadingV1': 'Para <span>{replace_value}</span>',
  'hero.learnmore': 'Leer más',
  'hero.eTextbook': 'Libro electrónico',
  'hero.goToPage.label': 'Ir a la página',
  'subscription.studyTitle': 'Preparación para estudiar',
  'print.printAvailTitle': '¿Quiere imprimir esta página? Aquí le indicamos cómo hacerlo.',
  'print.printAvailDesc': 'En su libro electrónico, seleccione el ícono de la cuenta en la parte superior derecha. Entre las opciones, elija "Imprimir página" y, luego, elija la configuración de impresión.',
  'print.printNotAvailTitle': 'La opción de impresión no está disponible para este libro electrónico.',
  'print.printNotAvailDesc': 'Para tener un acceso más cómodo sin conexión, descargue su título mediante la aplicación móvil Pearson+ y disfrute de la flexibilidad de estudiar en cualquier momento desde cualquier lugar.',
  'hero.header.cta': 'Ir a las herramientas de estudio',
  'hero.header.ctav2': 'Abrir Preparación para estudiar',
  'hero.marketing.title': 'Encuentre su libro electrónico',
  'hero.marketing.subTitle': 'Elija entre más de 2.000 libros electrónicos con audio, tarjetas didácticas, notas y mucho más. Solo $10,99 por mes por un periodo de 4 meses.',
  'hero.popularchannels.desc': 'Obtenga ayuda para el estudio con estas materias principales.',
  'hero.removecourse.title': '¿Desea eliminar el curso del panel?',
  'hero.removecourse.description': 'Puede volver a agregar este curso al panel haciendo clic en "Agregar curso".',
  'hero.removecourse.primaryCtaText': 'Eliminar',
  'hero.removecourse.secondaryCtaText': 'Cancelar',
  'hero.tableOfContents': 'Índice',
  'hero.search': 'Buscar',
  'hero.emptystate.cta': 'Buscar libros electrónicos',
  'hero.watch_it_again': 'Vuelva a verlo',
  'hero.mondly.learnLang.title': 'Aprenda un nuevo idioma gratis',
  'hero.mondly.subTitle': 'Los usuarios de libros de texto electrónicos de Pearson obtienen tres meses gratis de Mondly de Pearson.',
  'hero.mondly.description': 'La mayoría de las aplicaciones para aprender idiomas solo permiten aprender desde el inglés. Sin embargo, lo mejor es aprender desde su lengua materna; por eso, Mondly le permite aprender desde cualquiera de nuestros <strong>41 idiomas</strong>.',
  'hero.mondly.startLearningCTA': 'Comenzar a aprender',
  'hero.mondly.marketing.bestApp': 'Mejor aplicación',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Aplicación del año',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - Ganador de Europa, Oriente Medio y África 2017',
  'hero.mondly.marketing.editorChoice': 'Opción de editor',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Aprenda un idioma',
  'header.menu.moreAtPearson': 'Más en Pearson',
  'hero.subscriptionStatusTitle2': 'Sus recursos de Pearson+',
  'hero.startStudying': 'Comenzar a estudiar',
  'onboard.studyMaterials': 'Seleccione su materia y crearemos un tablero con material de estudio personalizado.',
  'hero.myETextbooks': 'Mis libros electrónicos',
  'header.continueInTheApp': 'Continuar en la aplicación',
  'hero.learnTxt': 'Aprender',
  'hero.examPrepTxt': 'Preparación para exámenes',
  'hero.aITutorTxt': 'Tutor con IA',
  'AI.toolTip': 'Pregúnteme lo que desee sobre su libro electrónico',
  'hero.studyExamPrepAllYourCourses': 'Preparación para estudiar para todos sus cursos',
  'header.qrCode.subHeaderTxt': 'Use este código QR para iniciar sesión de forma rápida y segura en la aplicación Pearson+ de su dispositivo móvil.',
  'header.qrCode.dontHaveApp': '¿No tiene la aplicación?',
  'header.qrCode.footerTxt': 'Escanee este código para dirigirse a la App Store o a Google Play. Una vez descargada la aplicación, vuelva a escanearlo para iniciar sesión.',
  'header.qrCode.errorMsg': 'No se cargó el código QR. Cierre e intente nuevamente.',
  'hero.yourETextbook': 'Su libro electrónico',
  'onboard.addCourseWithEtextBundle': 'Agregue un curso usando Preparación para estudiar',
  'onboard.disableTooltipText': 'Se agregaron todos los cursos de Preparación para estudiar.',
  'subscriptionstatus.bundlecta': 'Acceda a Preparación para estudiar',
  'subscriptionstatus.nonbundlecta': 'Acceda a Preparación para estudiar',
  'channel.genericBundle': 'Use Preparación para estudiar como ayuda en sus otros cursos',
  'channel.relatedBundle': 'También use Preparación para estudiar como ayuda en sus otros cursos',
  'onboard.courseAdded': 'Curso agregado.',
  'hero.flashcards': 'Tarjetas didácticas',
  'relatedChannelCard.title': 'Mejore su aprendizaje con este recurso relacionado',
  'relatedChannelCard.badgeText': 'Preparación para estudiar relacionado',
  'sessionInactivity.title': '¿Sigue aquí?',
  'sessionInactivity.description': 'Su sesión expirará en <b>%TIMER%</b> por inactividad.<br/>¿Quiere permanecer con la sesión activa?',
  'sessionInactivity.keepMeSignIn': 'Mantener mi sesión activa',
  'sessionInactivity.signOut': 'Cerrar sesión',
  'sessionTimeout.title': 'Su sesión expiró.',
  'sessionTimeout.description': 'Su sesión expiró por inactividad.',
  'print.qrCode.header': 'Use este código QR para abrir la aplicación de Pearson+ en su dispositivo móvil.',
  'print.qrCode.footer': 'Escanee este código para dirigirse a App Store o a Google Play. Una vez instalada la aplicación, vuelva a iniciar sesión para descargarla y acceder a su título.',
  'hero.nestest.title': 'Prepárese para su examen de certificación docente',
  'hero.nestest.subTitle': 'Los usuarios de Pearson+ ahora pueden acceder a cursos de preparación y pruebas de práctica basados en estándares nacionales para prepararse para sus exámenes de certificación docente.',
  'hero.channelAI.title': '¿Necesita ayuda? Puede contar con el tutor con IA.',
  'hero.channelAI.desc': 'Haga una pregunta y reciba ayuda con tareas paso a paso, recomendaciones de estudio y mucho más. Ayuda personalizada cuando la necesite.',
  'hero.channelAI.action': 'Pregúntele al tutor con IA ahora',
  'new': '¡Nuevo!',
  'hero.practice.numOfUsers': 'Esta sección tiene <b>{practice_num_of_users}</b> problemas de práctica.',
  'hero.practice.cta': 'Practicar ahora',
  'hero.practice.title': 'Problema de práctica',
  'diagnostics.errorMsg': 'No se cargó el diagnóstico. Cierre e intente nuevamente',
  'qrcode.title': 'Comenzar a estudiar en cualquier lugar',
  'qrcode.subtitle': 'Aprenda desde cualquier lugar, en cualquier momento con la aplicación móvil Pearson+. Descárguela ahora y descubra una experiencia de aprendizaje sencilla.',
  'qrcode.detailsv1': 'Con la aplicación Pearson+, puede usar este código QR para retomar desde donde lo dejó. Busque su libro, estudie con tarjetas didácticas, mire lecciones en video y más donde quiera que vaya.',
  'qrcode.detailsv2': 'Escanee este código QR cuando quiera iniciar sesión rápidamente y retomar desde donde dejó.',
  'qrcode.details': 'Con la aplicación Pearson+, puede usar este código QR para retomar desde donde lo dejó.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Aprenda desde cualquier lugar, en cualquier momento con la aplicación móvil Pearson+. Descárguela ahora y descubra una experiencia de aprendizaje sencilla.',
  'install': 'Install',
  'header.menu.createCourse': 'Nuevo curso',
  'header.dropdown.courses': 'Cursos',
  'header.dropdown.recentlyViewed': 'Visto recientemente',
  'header.dropdown.viewAll': 'Ver todos los cursos',
  'aet.courseHeader.inviteStudents': 'Invitar estudiantes',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Invite a los estudiantes a acceder a este libro electrónico copiando la dirección del enlace o las siguientes instrucciones en su correo electrónico o temario.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Vincular dirección',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copiar enlace',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instrucciones con la dirección del enlace',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copiar instrucciones',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Es momento de acceder a {bookTitle} el libro electrónico para {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Cuando todo esté listo, acceda a su libro electrónico en: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Se le pedirá que inicie sesión en su cuenta de Pearson actual. Si no tiene una cuenta de Pearson, podrá crear una.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': '¿Necesita ayuda?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Fechas de inicio:',
  'aet.courseHeader.endDate': 'Fecha de finalización:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Formato:',
  'aet.home.manageroster': 'Administrar lista',
  'aet.home.managegradesync': 'Administrar la sincronización de calificaciones',
  'aet.home.copycourse': 'Copiar curso',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': 'Actual',
  'aet.instructorCourse.tabs.past': 'Anterior',
  'aet.instructorCourse.tabs.courseSettings': 'Configuración del curso',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Administrar lista',
  'aet.instructorCourse.currentCourses.title': 'Cursos actuales',
  'aet.instructorCourse.pastCourses.title': 'Cursos pasados',
  'aet.instructorCourse.createOrCopy.title': 'Cree o copie un libro electrónico del curso de Pearson',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copiar el curso de otro instructor o crear uno nuevo',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copiar el curso de otro instructor',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Ingresar el ID del curso para encontrar el curso que quiere copiar.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Ingresar ID del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Buscó',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Crear nuevo curso desde el catálogo',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Buscar por título, autor, ISBN o palabras clave de temas.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Buscar...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Mostrar más',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Mostrar menos',
  'aet.instructorCourse.cancel': 'Cancelar',
  'aet.instructorCourse.loading': 'Cargando...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Sincronizar calificaciones',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Administrar la sincronización de calificaciones',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nombre del curso',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nombre de la sección',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institución',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'La institución es obligatoria',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Algo salió mal. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'No se encontraron resultados',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': 'Fecha de inicio del curso',
  'aet.instructorCourse.courseForm.endDateLabel': 'Fecha de finalización del curso',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Permitir que otros copien este curso',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Compartir este código con los instructores que quieran copiar este curso',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copiar código',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opcional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'El formulario tiene errores de validación',
  'aet.instructorCourse.courseForm.submitContinue': 'Continuar',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Guardando...',
  'aet.instructorCourse.courseForm.submitError': 'No pudimos crear su curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitEditError': 'No pudimos guardar sus cambios. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Guardar cambios',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiales del curso',
  'aet.instructorCourse.courseForm.resolveError': 'No pudimos cargar los materiales del curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Últimos vistos',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Agregado recientemente',
  'aet.instructorCourse.coursesSort.aToZ': 'De la A a la Z',
  'aet.instructorCourse.coursesSort.zToA': 'De la Z a la A',
  'aet.instructorCourse.manageRoster.column.name': 'Nombre',
  'aet.instructorCourse.manageRoster.column.role': 'Función',
  'aet.instructorCourse.manageRoster.column.email': 'Correo electrónico',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Estado',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Se inscribió el {date}',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': 'Estudiante',
  'aet.instructorCourse.roster.role.ta': 'AE',
  'aet.instructorCourse.roster.role.instructor': 'Instructor',
  'aet.instructorCourse.roster.status.active': 'Activo',
  'aet.instructorCourse.roster.status.inactive': 'Inactivo',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Todos los miembros',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Estudiantes activos',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Estudiantes inactivos',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Asistente de enseñanza (AE)',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instructor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Fecha de creación del curso:',
  'aet.instructorCourse.noCoursesFound': 'No se encontraron cursos',
  'aet.instructorCourse.backButton': 'Atrás',
  'aet.instructorCourse.selectCourse': 'Seleccionar curso',
  'aet.home.linkedToLms': 'Vinculado con su LMS',
  'aet.instructorCourse.courseForm.title.create': 'Crear curso',
  'aet.instructorCourse.courseForm.title.copy': 'Copiar curso',
  'aet.instructorCourse.courseForm.title.edit': 'Información del curso',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Asignaciones',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Contenido de la asignación',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Fechas límites de las asignaciones',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Aspectos destacados y notas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Color de resaltador',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Texto de la nota',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Estado compartido',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Lista de estudiantes y participación',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Nombre del estudiante',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Dirección de correo electrónico',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Inscripción',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Finalización e información',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Ajustes',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Datos copiados',
  'aet.studentRoster.manageStudentRosterButton': 'Administrar lista de estudiantes',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Exportar progreso de los estudiantes',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Estado:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Inscripción:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Función:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '¿Promover a {studentName}?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Como asistente de enseñanza, esta persona podrá ver el progreso y el desempeño de todos los estudiantes en esta clase.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'También podrán gestionar los estudiantes y asignaciones, sin embargo, no podrán borrar la clase.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promover a asistente de enseñanza',
  'aet.home.manageRoster.searchPlaceholder': 'Buscar estudiante',
  'aet.home.manageRoster.inactivateButtonLabel': 'Inactivar estudiantes seleccionados',
  'aet.home.manageRoster.FilterLabel': 'Mostrar',
  'aet.home.manageRoster.updatingMessage': 'Actualizando lista... Esto puede tardar algunos minutos.',
  'aet.home.courses.search.searchPlaceHolder': 'Buscar sus cursos',
  'aet.courses.emptyStateDescription': 'Empiece a crear su curso eligiendo una de las siguientes opciones.',
  'nativePromoBanner.continueInBrowser': 'Continuar en el navegador',
  'globalnav.tooltip.hideNavText': 'Ocultar navegación',
  'globalnav.tooltip.showNavText': 'Mostrar navegación',
  'aet.syllabus.progressTitle': 'Extrayendo...',
  'aet.syllabus.progressDesc': 'Espere mientras procesamos su temario.',
  'aet.syllabus.uploadInputLabel': 'Arrastre y suelte sus archivos aquí o haga clic para cargarlos',
  'aet.syllabus.uploadSyllabusTabLabel': 'Cargar temario',
  'aet.syllabus.dateAdjusterTabLabel': 'Modificador de fechas',
  'aet.syllabus.addManuallyTabLabel': 'Agregar asignaciones manualmente',
  'aet.syllabus.addEditLaterText': 'Siempre puede agregar y editar asignaciones más tarde',
  'aet.syllabus.editAssignmentLabel': 'Editar asignación',
  'aet.syllabus.addAssignmentLabel': 'Agregar asignación',
  'aet.syllabus.assignmentTitleLabel': 'Título de la asignación',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Fecha límite',
  'aet.syllabus.editDueDateLabel': 'Editar fecha límite',
  'aet.syllabus.chaptersCoveredLabel': 'Seleccione los capítulos o secciones que se abordarán.',
  'aet.syllabus.updateCtaLabel': 'Actualizar asignación',
  'aet.syllabus.addCtaLabel': 'Agregar asignación',
  'aet.syllabus.uploadLabel': 'Cargar',
  'aet.syllabus.confirmLabel': 'Confirmar',
  'aet.syllabus.addContentLabel': 'Agregar contenido',
  'aet.syllabus.addEditContentLabel': 'Agregar/editar contenido',
  'aet.syllabus.notPublishedLabel': 'No se publicó',
  'aet.syllabus.updateDatesLabel': 'Actualizar fecha',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Se actualizó su fecha límite. Revísela y publíquela.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Se actualizó la información de su capítulo/sección. Revísela y publíquela.',
  'aet.syllabus.unassignedCoverageStatus': 'Algunos capítulos aún no se asignaron. Asígnelos antes de publicar.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': '¿Eliminar asignación?',
  'aet.deleteAssignmentTitleMultiple': '¿Eliminar asignaciones?',
  'aet.deleteAssignmentWarning': 'Esta acción no se puede deshacer y todos los datos del estudiante y las entregas relacionadas ya no se podrán ver.',
  'aet.deleteAssignmentKeepCTA': 'Mantener asignación',
  'aet.deleteAssignmentDeleteCTA': 'Eliminar',
  'aet.assignments.loadingAsset': 'Cargando activo...',
  'aet.assignments.addToDate': 'Agregar a la fecha',
  'aet.assignments.previewAsStudent': 'Vista previa como estudiante',
  'aet.assignments.questionsAndTopics': 'Preguntas y temas',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Listo',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Fecha límite',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Total de preguntas',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Pregunta {count} de {total}',
  'aet.assignments.publishToStudents': 'Publicar para los estudiantes',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Agregar fecha',
  'aet.doneLabel': 'Listo',
  'aet.assignments.dueDateLabel': 'Fecha límite de la asignación',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': 'Configuración manual',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Use información en tiempo real para detectar deficiencias en el aprendizaje y poder actuar de forma temprana con confianza',
  'aet.onboarding.promotion.feature.3': 'Los estudiantes reciben más ayuda con retroalimentación específica y la IA de Pearson incorporada',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': 'No tiene asignaciones programadas para esta semana.',
  'aet.assignments.progressTitle': 'Progreso',
  'aet.assignments.performanceTitle': 'Confianza',
  'aet.assignments.completionTitle': 'Culminación',
  'aet.assignments.statusTitle': 'Estado',
  'aet.assignments.addTooltip': 'Agregar asignación',
  'aet.assignments.deleteTooltip': 'Eliminar las asignaciones seleccionadas',
  'aet.assignments.selectToDeleteLabel': 'Modo seleccionar y eliminar',
  'aet.assignments.bulkEditTooltip': 'Editar asignaciones en bloque',
  'aet.assignments.title': 'Asignaciones',
  'aet.assignments.assignmentTitle': 'Asignación',
  'aet.assignments.dueDate': 'Fecha límite',
  'aet.tabular.searchPlaceholder.assignments': 'Buscar asignaciones',
  'aet.tabular.searchPlaceholder.students': 'Buscar estudiantes',
  'aet.tabular.searchPlaceholder.questions': 'Buscar preguntas',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Uno o más estudiantes tienen extensiones de fecha límite para todas las asignaciones',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Uno o más estudiantes tienen extensiones de fecha límite para esta asignación',
  'aet.assignemnts.masterDueDateInfoTooltip': 'A uno o más estudiantes se le otorgaron extensiones de fecha límite. Busque el ícono de información para identificar estas asignaciones.',
  'aet.home.loading': 'Cargando...',
  'aet.home.errorFetchingAssignments': 'Error al obtener las asignaciones',
  'aet.home.dueThisWeekTitle': 'Vence esta semana',
  'aet.home.allCaughtUpTitle': '¡Tiene todo al día!',
  'aet.home.allCaughtUpDescription': 'No tiene asignaciones programadas para esta semana.',
  'aet.home.suggestedRemediationTitle': 'Revisión sugerida por Preparación para estudiar',
  'aet.home.noSuggestedRemediationTitle': 'No hay material para revisar sugerido',
  'aet.home.noSuggestedRemediationDescription': 'Vuelva a consultar después de su próxima asignación.',
  'aet.home.assignmentIncludesTitle': 'La asignación incluye',
  'aet.home.sectionsLabel': 'Capítulo(s)',
  'aet.home.questionsCount': '{count} preguntas',
  'aet.home.dueLabel': 'Fecha límite: {dueDate}',
  'aet.home.due': 'Programada:',
  'aet.home.progressCompletedLabel': 'Completada',
  'aet.home.progressCompletedPastDueLabel': 'Completada vencida',
  'aet.home.progressInProgressLabel': 'En progreso',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'No se comenzó',
  'aet.home.progressCountOfTotal': '{count} de {total}',
  'aet.home.NotAttemptedLabel': 'No se intentó hacerla',
  'aet.home.questionsTotalLabel': 'Preguntas totales',
  'aet.home.progressCompletedOnTimeLabel': 'Completada a tiempo',
  'aet.home.segmentGreatLabel': 'Excelente',
  'aet.home.segmentGettingThereLabel': 'Aceptar',
  'aet.home.segmentNeedsReviewLabel': 'En desarrollo',
  'aet.home.segmentOkayLabel': 'Aceptar',
  'aet.home.editAssignmentTooltip': 'Editar asignación',
  'aet.home.deleteAssignmentTooltip': 'Eliminar asignación',
  'aet.home.viewDetailsButton': 'Ver detalles',
  'aet.home.viewAsStudentButton': 'Ver como estudiante',
  'aet.home.welcomeButtonText': 'Comenzar →',
  'aet.review.emptyStateTitle': 'No hay nada para revisar',
  'aet.review.emptyStateDescription': 'Vuelva a consultar después de su próxima asignación.',
  'aet.dashboard.tabs.upNext': 'A continuación',
  'aet.dashboard.tabs.welcome': 'Bienvenido',
  'aet.dashboard.tabs.assignments': 'Asignaciones',
  'aet.dashboard.tabs.review': 'Revisar',
  'aet.dashboard.tabs.studentRoster': 'Estudiantes',
  'aet.dashboard.classSchedule': 'Programa de la clase:',
  'aet.syllabus.dueTimeLabel': 'Hora límite',
  'hero.accessEducatorGuides': 'Acceder a las guías del educador',
  'aet.assignment.save': 'Guardar',
  'aet.assignment.finish': 'Finalizar',
  'aet.assignment.saveAndAdd': 'Guardar y agregar otra',
  'aet.assignment.delete': 'Eliminar',
  'aet.assignment.saveAndClose': 'Guardar y cerrar',
  'aet.studentRoster.title': 'Estudiantes',
  'aet.studentRoster.titlev1': 'Estudiante',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Fechas límites',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Estándar',
  'aet.studentRoster.dueDateAdjustment.option.2': '2 días más',
  'aet.studentRoster.dueDateAdjustment.option.3': '3 días más',
  'aet.studentRoster.dueDateAdjustment.option.5': '5 días más',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '1 semana más',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '2 semana más',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Último día de la clase',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} asignaciones actualizadas',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Las asignaciones vencidas no se pudieron actualizar automáticamente. Edite cada una para definir una nueva fecha límite.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No se pudieron actualizar las fechas límites',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Todas las asignaciones están vencidas y no se pudieron actualizar automáticamente. Edite cada una para definir una nueva fecha límite.',
  'aet.bulkEdit.bulkSplitInstruction': 'Dividiremos sus asignaciones en partes iguales.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Primera asignación a entregar',
  'aet.bulkEdit.lastAssignmentDue': 'Última asignación a entregar',
  'aet.bulkEdit.assignmentsDueDays': '¿Qué días quiere que se entreguen las asignaciones?',
  'aet.bulkEdit.addEditLaterText': 'Usamos IA para crear asignaciones. Siempre puede agregar y editar asignaciones más tarde.',
  'aet.bulkEdit.monday': 'Lunes',
  'aet.bulkEdit.tuesday': 'Martes',
  'aet.bulkEdit.wednesday': 'Miércoles',
  'aet.bulkEdit.thursday': 'Jueves',
  'aet.bulkEdit.friday': 'Viernes',
  'aet.bulkEdit.saturday': 'Sábado',
  'aet.bulkEdit.sunday': 'Domingo',
  'aet.toast.assignmentCreated.title': '¡Asignación creada!',
  'aet.toast.assignmentCreated.single': 'Se nombró automáticamente como {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} se crearon asignaciones',
  'aet.toast.assignmentUpdated.title': 'Actualización exitosa',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} se actualizó',
  'aet.toast.assignmentUpdated.multiple': 'Se actualizaron {count} asignaciones',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': 'El contenido de las asignaciones puede editarse hasta que los estudiantes empiecen a trabajar.',
  'aet.toast.viewAssignment': 'Ver asignación',
  'aet.toast.viewAssignments': 'Ver asignaciones',
  'aet.welcome.title': 'Su libro electrónico de Pearson ahora está vinculado a su curso de LMS',
  'aet.welcome.LMSAccounTitle': 'Explorar ideas',
  'aet.welcome.LMSAccounDescription': 'Vea con qué temas exactamente está teniendo dificultades la clase.',
  'aet.welcome.createAssignmentsTitle': 'Cree asignaciones',
  'aet.welcome.createAssignmentsDescription': 'Asigne capítulos manualmente o cargando el plan de estudios.',
  'aet.welcome.progressViewTitle': 'Haga un seguimiento del desempeño en su LMS',
  'aet.welcome.progressViewDescription': 'Elija la configuración de sincronización de grado en su curso de LMS',
  'aet.assignmentDetails.noAssignmentFound': 'No se encontraron asignaciones',
  'aet.assignments.loadingErrorTitle': 'La asignación no puede cargarse en este momento',
  'aet.assignments.loadingErrorDescription': 'Actualice la página o consulte más tarde',
  'aet.assignmentStudentDetails.noDataFound': 'Aún sin datos',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'No hay estudiantes registrados',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Los estudiantes se unirán a la clase a medida que compren el libro electrónico.',
  'aet.home.editAssignmentTooltipDisabled': 'No se puede editar: trabajo de estudiante en progreso',
  'aet.home.deleteAssignmentTooltipDisabled': 'No se puede eliminar trabajo de estudiante en progreso',
  'aet.home.StudentDetails.questions': 'Preguntas',
  'aet.home.StudentDetails.attempts': 'Intentos',
  'aet.home.StudentDetails.comprehension': 'Confianza',
  'hero.titleInfo.tooltip': 'Información del título',
  'aet.home.publishAssignments': 'Publicar todas las asignaciones',
  'aet.assignments.saveScheduleAsDraft': 'Guardar calendario como borrador',
  'aet.assignments.reviewBeforePublishAlert': 'Revise sus asignaciones y publíquelas para que los estudiantes puedan verlas.',
  'aet.assignments.copiedCoursePublishAlert': 'Agregue fechas a sus asignaciones copiadas y publíquelas para que los estudiantes puedan verlas.',
  'aet.assignments.allSetPublishAlert': '¿Todo listo? Publique sus asignaciones para que los estudiantes puedan verlas.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Cierto contenido se creó usando IA basándose en los materiales de aprendizaje de Pearson. Si bien Pearson tiene un proceso para validar el contenido generado, la IA generativa puede crear información poco precisa sobre personas, lugares o hechos.',
  'aet.home.bulkEditTitle': 'Editar asignaciones en bloque',
  'aet.home.bulkEditSubtitle': 'Haga cambios en el temario, luego, vuelva a cargarlo aquí. Sus asignaciones y fechas programadas se actualizarán para que coincidan.',
  'aet.home.createAssignmentTitle': 'Cree asignaciones',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Se incluyó en otra asignación',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Algunas secciones se incluyeron en otra asignación',
  'aet.welcome.welcome.Title': '¡Bienvenido!',
  'aet.home.student.roaster.ProgressTitle': 'Culminación total',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Vuelva a consultar cuando los estudiantes empiecen la asignación.',
  'aet.home.whatDueThisWeekTitle': 'Esto es lo que se vence esta semana',
  'aet.assignments.edit.errorTitle': '{count} las asignaciones tienen errores',
  'aet.assignments.edit.errorSubTitle': 'Las asignaciones con errores no pueden publicarse. Edítelas o publique sin ellas.',
  'aet.assignments.edit.publishAnyway': 'Publicar de todas formas',
  'aet.assignments.edit.editAssignments': 'Editar asignaciones',
  'aet.assignments.edit.validationInfoToolTip': 'Editar asignaciones para eliminar errores',
  'aet.assignments.error.assignmentCreated.title': 'Todas las asignaciones tienen errores',
  'aet.assignments.error.assignmentCreated.description': 'Las asignaciones con errores no pueden publicarse. Edítelas o intente con un temario diferente.',
  'aet.assignments.error.uploadSyllabus': 'Cargar temario',
  'aet.assignments.error.editAssignments': 'Editar asignaciones',
  'aet.mondly.title': 'Idiomas',
  'aet.studentRoster.errorState.title': 'La lista de estudiantes no está disponible',
  'aet.studentRoster.errorState.description': 'No pudimos cargar la lista de estudiantes. Intente actualizar o consulte más tarde.',
  'aet.assignments.sectionLabel': 'secciones',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'preguntas',
  'aet.assignments.assignmentsLabel': 'asignaciones',
  'aet.assignments.performanceProgressBar': 'Barra de progreso de desempeño',
  'aet.assignments.completionProgressBar': 'Barra de progreso de finalización',
  'aet.syllabus.deleteConfirmationSubtitleSingle': '¿Está seguro de que quiere eliminar esta asignación?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': '¿Está seguro de que quiere eliminar estas asignaciones?',
  'aet.home.nextAssignmentTitle': 'Siguiente asignación',
  'aet.home.courseSettings': 'Configuración del curso',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Recursos de libros electrónicos de Pearson+',
  'aet.home.etextbookInformation': 'Información del libro electrónico',
  'aet.multiple.deleteAssignmentKeepCTA': 'Mantener asignaciones',
  'aet.syllabus.processingText.header': 'Estamos organizando las lecturas asignadas para su clase. Esto solo tomará un momento.',
  'aet.syllabus.processingText.uploading': 'Cargando su documento',
  'aet.syllabus.processingText.activating': 'Activando componentes de IA',
  'aet.syllabus.processingText.extracting': 'Extrayendo asignaciones de lectura',
  'aet.syllabus.processingText.mapping': 'Asignando al contenido del libro de texto',
  'aet.syllabus.processingText.finishing': 'Finalizando',
  'aet.syllabus.uploadErrorMessage': 'Asegúrese de que su archivo PDF o .docx sea menor a 10MB y que su conexión a internet sea estable',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No se encontraron asignaciones de lectura',
  'aet.syllabus.uploadNoAssignmentsDescription': 'No pudimos obtener asignaciones de lectura de este archivo. Puede agregarlas manualmente.',
  'aet.syllabus.uploadFailedRetryCTA': 'Inténtelo de nuevo',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Compruebe que su temario tenga <qualities a syllabus should have for this to work> y vuelva a intentarlo o cambie a creación de asignación manual.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Creación manual',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Algo salió mal',
  'aet.syllabus.uploadModal.genericFailure.body1': 'No pudimos cargar ni procesar el temario.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Compruebe su conexión y vuelva a intentarlo o cambie a creación de asignación manual.',
  'aet.syllabus.uploadModal.successTotal.title': 'Lista para revisar',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Lista para revisar',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Revisar asignaciones',
  'aet.syllabus.selectChapterWithQuestions': 'Seleccionar un capítulo con preguntas.',
  'preferenceSetting.subTitle': 'Esta configuración será la predeterminada para todos los estudiantes en este curso.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interacciones con IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Habilitar la herramienta de estudio con IA y los resúmenes de IA en los resultados de búsqueda',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Mostrar recursos de preparación para estudiar relacionados con este libro',
  'aet.syllabus.footer': 'La creación de asignaciones se realiza con IA.',
  'aet.dashboard.footerDialogDeatils': 'Las preguntas de la asignación se crearon usando IA generativa basándose en los materiales de aprendizaje de Pearson. Si bien Pearson tiene un proceso para validar el contenido generado, la IA generativa puede crear información poco precisa sobre personas, lugares o hechos. La IA también se usa para agrupar el contenido en tareas, basándose en el temario o el programa que proporcione.',
  'aet.review.footer': 'Creado usando IA',
  'aet.footerCard.dismiss': 'Descartar',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Preparación para estudiar es una herramienta adicional que apoya el aprendizaje al proporcionar a los estudiantes videos y problemas de práctica personalizados para este curso.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Es posible que se les pida a los estudiantes cuyo plan de acceso no incluya Preparación para estudiar que se suscriban para seguir usando los recursos de Preparación para estudiar.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Los estudiantes que ya hayan comprado Preparación para estudiar no se verán afectados por esta configuración.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Conozca más acerca de los beneficios de Preparación para estudiar',
  'aet.home.viewCourseId': 'Ver ID del curso',
  'aet.home.copy': 'Copiar',
  'aet.home.copied': 'Copiado',
  'aet.home.courseLabel': 'ID del curso:',
  'schoolInfoCard.addUniversity': 'Agregar escuela',
  'schoolInfoCard.title': 'Información de la escuela',
  'schoolInfoCard.titleV1': 'Cuéntenos sobre su curso',
  'schoolInfoCard.cta': 'Comenzar',
  'schoolInfoCard.pickInstitution': 'Elegir escuela',
  'schoolInfoCard.addUniversityTitle': 'Agregar su escuela',
  'schoolInfoCard.addUniversitySubtitle': 'Conocer su escuela y curso nos permite recomendarle los materiales de estudio más útiles.',
  'schoolInfoCard.searchPlaceholder': 'Buscar su escuela...',
  'schoolInfoCard.skip': 'Omitir este paso',
  'schoolInfoCard.nextStep': 'Siguiente paso',
  'schoolInfoCard.notInList': 'Mi escuela no está en la lista',
  'schoolInfoCard.noResults': 'No se encontraron escuelas que coincidan con su búsqueda',
  'schoolInfoCard.noResultsHeading': '¿No encuentra su escuela?',
  'schoolInfoCard.noResultsInstruction': 'Ingrese el nombre completo abajo',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nombre de la escuela',
  'schoolInfoCard.addInstitutionLabel': 'Agregar esta escuela',
  'aet.assignments.assignmentTitlePlaceholder': 'Ingresar un título',
  'aet.assignments.titleValidation.titleRequired': 'Se requiere un título para la asignación.',
  'aet.assignments.titleValidation.titleTooLong': 'El título de la asignación no puede superar los {0} caracteres.',
  'aet.assignments.titleValidation.titleInvalidChar': 'El título de la asignación contiene caracteres no admitidos.',
  'aet.assignments.titleValidation.titleDuplicate': 'El título de la asignación ya existe.',
  'aet.syllabus.timeZoneLabel': 'Zona horaria',
  'aet.review.reviewReadingFromAssignments': 'Revisar lectura desde la asignación',
  'aet.assignments.chaptersLabel': 'capítulo(s)',
  'menu.myAccount.subTitle': 'Su institución aparece aquí',
  'menu.myAccount.subTitleNotAvailable': 'Puede agregar la institución aquí más tarde en cualquier momento.',
  'schoolInfoCard.toastMessage': 'Universidad guardada',
  'aet.review.threeDotMenu.askAI': 'Preguntar a la IA',
  'aet.home.suggestedRemediationSubtitle': 'Ver práctica y videos relevantes para dominar los temas del curso.',
  'aet.home.laggedQuestionLabel': 'Preguntas marcadas',
  'aet.home.correctAnswer': 'Respuesta correcta',
  'aet.home.incorrectAnswer': 'Respuesta incorrecta más común',
  'aet.home.behaviourTrendsLabel': 'Información sobre preguntas',
  'aet.home.strugglingStudentsLabel': 'Estudiantes con dificultades',
  'aet.home.patternsInStudensAiLabel': 'Patrones en el uso de IA de los estudiantes',
  'aet.home.questionLabel': 'Pregunta',
  'aet.home.studentAskingSimilarQuestions': 'Estudiantes que hicieron preguntas similares',
  'aet.home.assignmentDifficultQuestions': 'Preguntas difíciles',
  'aet.home.behaviorTrends': 'Información sobre preguntas',
  'aet.home.behaviors': 'Indicadores de desempeño',
  'aet.home.mostDifficultTopics': 'Preguntas más difíciles',
  'aet.home.commentsFromStudentLabel': 'Comentarios de los estudiantes',
  'aet.home.disregard': 'Desestimar',
  'aet.home.reportAsInaccurate': 'Reportar como incorrecto',
  'aet.home.Flagged': 'Marcado',
  'aet.home.reportQuestionTitle': 'Reportar pregunta',
  'aet.home.reportQuestionLabel': '¿Por qué esa pregunta era incorrecta?',
  'aet.home.showComments': 'Mostrar comentarios',
  'aet.home.studentReports': 'informes de estudiantes',
  'aet.home.placeholderText': 'Explique...',
  'aet.home.reportQuestion.notRelevant': 'No es pertinente',
  'aet.home.reportQuestion.notCorrect': 'No es correcto',
  'aet.home.reportQuestion.unsafe': 'Inseguro/dañino',
  'aet.home.reportQuestion.somethingElse': 'Otra cosa',
  'aet.home.StudentDetails.assistedByAI': 'Con ayuda de IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'No hay estudiantes con dificultades en este momento',
  'aet.home.strugglingStudents.emptyStateDescription': 'Vuelva a consultar más tarde',
  'aet.home.overallStatus.excelling': 'Sobresale',
  'aet.home.overallStatus.fallingBehind': 'Se está quedando atrás',
  'aet.home.overallStatus.keepingUp': 'Progreso adecuado',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Mostrar solo "Preguntas difíciles"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Mostrar solo "Estudiantes con dificultades"',
  'aet.home.viewQuestionInAssignment': 'Ver pregunta en la asignación',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Incorrecto en los primeros intentos',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Muchos intentos incorrectos',
  'aet.home.insightRisk.lowConfidence': 'Confianza baja',
  'aet.home.insightRisk.mediumConfidence': 'Confianza media',
  'aet.home.insightRisk.lowEngagement': 'Poca participación',
  'aet.home.insightRisk.countOfStudents': '{count} de {total} estudiantes',
  'aet.home.insightRisk.na': 'N/A',
  'aet.home.strugglingStudentsHereLabel': 'Estudiantes con dificultades aquí',
  'aet.home.insightRisk.didNotAttempt': 'No se intentó',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'Integración de LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default esCo;
